import React from 'react'

function Layout({ children }) {
    return (
        <React.Fragment>            
            {children}            
        </React.Fragment>
    );
}

export default Layout